export default __webpack_public_path__ + "static/media/mentor.9c00d047.png";